"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TxDisplayComponent = /** @class */ (function () {
    function TxDisplayComponent() {
    }
    TxDisplayComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(TxDisplayComponent.prototype, "file", {
        get: function () {
            return this._file;
        },
        set: function (file) {
            this._file = file;
        },
        enumerable: true,
        configurable: true
    });
    TxDisplayComponent.prototype.openFile = function () {
        window.open(this.file.path, '_blank');
    };
    TxDisplayComponent.ctorParameters = function () { return []; };
    return TxDisplayComponent;
}());
exports.TxDisplayComponent = TxDisplayComponent;
//# sourceMappingURL=tx-display.component.js.map


// WEBPACK FOOTER //
// tx-display.component.js